import { render, staticRenderFns } from "./TransferLongTimeDetail.vue?vue&type=template&id=5aa78d3c&scoped=true"
import script from "./TransferLongTimeDetail.vue?vue&type=script&lang=js"
export * from "./TransferLongTimeDetail.vue?vue&type=script&lang=js"
import style0 from "./TransferLongTimeDetail.vue?vue&type=style&index=0&id=5aa78d3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa78d3c",
  null
  
)

export default component.exports